import tokeys from "tokeys";

export default tokeys(["GET_ALL_THREADS", "POST_THREAD", "GET_THREAD"]);
